import React from "react";
import {
  Input,
  SearchModeSegment,
  SEARCH_MODE_FIELD_PADDING_RIGHT,
} from "../../controls";
import { IconButton, InputAdornment } from "@mui/material";
import { SearchRounded } from "@mui/icons-material";
import Form from "../Form";
import { useTranslation } from "react-i18next";

const DeepSearch = ({
  setSearchVal,
  searchVal,
  handleSearch,
  searchModes,
  searchMode,
  setSearchMode,
}) => {
  const { t } = useTranslation();
  const handleChange = (e) => {
    setSearchVal(e.target.value);
  };

  const hasModes = searchModes?.length > 1;
  // The placeholder names what Code reads, so the active scope is visible even
  // when the eye is on the text rather than the switch.
  const placeholder =
    hasModes && searchMode === "code"
      ? t("searchCodePlaceholder")
      : t("deepSearch");

  const searchButton = (position) => (
    <InputAdornment position={position}>
      <IconButton
        type="submit"
        size="small"
        aria-label={t("search")}
        sx={{ p: "6px", color: "text.secondary" }}
      >
        <SearchRounded fontSize="small" />
      </IconButton>
    </InputAdornment>
  );

  return (
    <div className={`w-full ${hasModes ? "md:w-[340px]" : "md:w-[250px]"}`}>
      <Form noValidate onSubmit={handleSearch}>
        <Input
          name="search"
          placeholder={placeholder}
          size="small"
          onChange={handleChange} // Fixed name
          value={searchVal}
          sx={{
            "& .MuiInputBase-root": hasModes
              ? { paddingLeft: "4px", paddingRight: SEARCH_MODE_FIELD_PADDING_RIGHT }
              : { paddingRight: "2px" },
          }}
          // With modes the box takes the desktop till's scan-bar layout: the search
          // icon leads (still the submit button) and the scope track sits at the end.
          InputProps={
            hasModes
              ? {
                  startAdornment: searchButton("start"),
                  endAdornment: (
                    <SearchModeSegment
                      modes={searchModes}
                      value={searchMode}
                      onChange={setSearchMode}
                    />
                  ),
                }
              : { endAdornment: searchButton("end") }
          }
        />
      </Form>
    </div>
  );
};

export default DeepSearch;
